// extracted by mini-css-extract-plugin
export default {"wrapper":"products_wrapper__yjWb3"};